var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#51D0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9716 5.83398H12.0316C8.58491 5.83398 8.31908 8.93232 10.1799 10.619L19.8232 19.3823C21.6841 21.069 21.4182 24.1673 17.9716 24.1673H12.0316C8.58491 24.1673 8.31908 21.069 10.1799 19.3823L19.8232 10.619C21.6841 8.93232 21.4182 5.83398 17.9716 5.83398Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeBlue);
export default __webpack_public_path__ + "static/media/time-blue.04a3d727c39517413dafe83e584dd39e.svg";
export { ForwardRef as ReactComponent };